<div *ngIf="areaList.length > 0">
    <div style="display: flex; justify-content: end;">
        <tyl-button image="Expand All.png" label="Expand All" (clickEvent)="expandAll(true)"></tyl-button>
        <tyl-button image="Collapse All.png" label="Collapse All" (clickEvent)="expandAll(false)"></tyl-button>
    </div>
    <mat-table #table [dataSource]="angularMatData" multiTemplateDataRows matSort matSortDisableClear
        id="medicalDataListingGrid" aria-label="Medical Data Listing Data Table" tabindex="0">
        <ng-container matColumnDef="Select">
            <mat-cell *matCellDef="let area; let i=index;" style="max-width:80px;">
                <tyl-checkbox [(checked)]="area.Select" (click)="$event.stopPropagation()"
                    (change)="medicalAreaChkChange()">
                </tyl-checkbox>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Area">
            <mat-cell *matCellDef="let area" style="text-align:left;">
                <b>
                    {{area.MEDICALAREA | translate}}
                </b>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Expand">
            <mat-cell *matCellDef="let area let i = index" style="max-width:40px;">
                <span *ngIf="area.Fileds.length > 0" aria-label="Expand row for more details">
                    <i [ngClass]="checkExpanded(area) ? 'detail-row-collapsed-icon' : 'detail-row-expanded-icon'" class="material-icons"
                        aria-hidden="true"></i>
                </span>
            </mat-cell>
        </ng-container>
        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let areaRow" [attr.colspan]="3" style="width:100%;">
                <mat-table [dataSource]="areaRow.Fileds" style="width: 100%"
                    aria-label="Medical Data Listing Fields Table" tabindex="0">
                    <ng-container matColumnDef="FIELDTEXT">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell *matCellDef="let field; let i=index">
                            {{field.FIELDTEXT}}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="FROM">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell *matCellDef="let field; let i=index">
                            <tyl-form-field style="width:120px"
                                *ngIf="field.DEFAULTVALUE.length == 0 && field.FIELDDATATYPE.toUpperCase()!= 'DATETYPE'">
                                <input matInput type="text" name="txt{{field.FIELDTEXT}}_{{i}}" [(ngModel)]="field.FROM"
                                    id="txt{{field.FIELDTEXT}}_{{i}}" (change)="validate(areaRow, field);"
                                    [disabled]="!areaRow.Select" />
                            </tyl-form-field>
                            <tyl-datepicker style="width:120px"
                                *ngIf="field.DEFAULTVALUE.length == 0 && field.FIELDDATATYPE.toUpperCase()== 'DATETYPE'"
                                (valueChange)="dateChange($event,areaRow, field,'FROM');" label="" [(value)]="field.FROM"
                                [disabled]="!areaRow.Select" id="dtp{{field.FIELDTEXT}}_{{i}}">
                            </tyl-datepicker>
                            <tyl-form-field style="width:120px" *ngIf="field.DEFAULTVALUE.length > 0">
                                <mat-select name="ddl{{field.FIELDTEXT}}_{{i}}" [(ngModel)]="field.FROM"
                                    id="ddl{{field.FIELDTEXT}}_{{i}}" (selectionChange)="validate(areaRow, field);"
                                    [disabled]="!areaRow.Select">
                                    <mat-option *ngFor="let dataItem of field.Lookup" [value]="dataItem.ValueField">
                                        {{dataItem.TextField}}
                                    </mat-option>
                                </mat-select>
                            </tyl-form-field>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="TO">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell *matCellDef="let field; let i=index">
                            <tyl-form-field style="width:120px"
                                *ngIf="field.DEFAULTVALUE.length == 0 && field.FIELDDATATYPE.toUpperCase()!= 'DATETYPE'">
                                <input matInput type="text" name="txt{{field.FIELDTEXT}}_{{i}}" [(ngModel)]="field.TO"
                                    id="txt{{field.FIELDTEXT}}_{{i}}" (change)="validate(areaRow, field);"
                                    [disabled]="!areaRow.Select" />
                            </tyl-form-field>
                            <tyl-datepicker style="width:120px"
                                *ngIf="field.DEFAULTVALUE.length == 0 && field.FIELDDATATYPE.toUpperCase()== 'DATETYPE'"
                                (valueChange)="dateChange($event,areaRow, field,'TO');" label="" [(value)]="field.TO"
                                [disabled]="!areaRow.Select" id="dtp{{field.FIELDTEXT}}_{{i}}">
                            </tyl-datepicker>
                            <tyl-form-field style="width:120px" *ngIf="field.DEFAULTVALUE.length > 0">
                                <mat-select *ngIf="field.DEFAULTVALUE.length > 0" name="ddl{{field.FIELDTEXT}}_{{i}}"
                                    [(ngModel)]="field.TO" id="ddl{{field.FIELDTEXT}}_{{i}}"
                                    [disabled]="!areaRow.Select" (selectionChange)="validate(areaRow, field);">
                                    <mat-option *ngFor="let dataItem of field.Lookup" [value]="dataItem.ValueField">
                                        {{dataItem.TextField}}
                                    </mat-option>
                                </mat-select>
                            </tyl-form-field>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="columnsToDisplayDetailRow"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: columnsToDisplayDetailRow;" style="overflow: hidden;"
                        tabindex="0">
                    </mat-row>
                </mat-table>
            </td>
        </ng-container>
        <mat-row *matRowDef="let row; columns: columnsToDisplay;" tabindex="0"
            [ngStyle]="{'background-color':'#e8eaf6'}" style="padding:0px;overflow: hidden;" matRipple
            (click)="toggleExpanded(row)"></mat-row>
        <mat-row class="mat-detail-row" *matRowDef="let row; columns: ['expandedDetail']"
            [@detailExpand]="checkExpanded(row) && row.Fileds.length > 0 ? 'expanded' : 'collapsed'"
            style="overflow: hidden"></mat-row>
    </mat-table>
</div>